import * as ng from 'angular';

import * as uib from 'angular-ui-bootstrap';
import { SurveyItemsApiService } from './survey-items-api.service';

export class EditSurveyItemChoiceController {
   static $inject = [
      '$uibModalInstance', 'surveyItemsApi', 'surveyItemChoice', 'languages', 'language'
   ];

   mode:'edit'|'add';
   surveyItemChoice;

   constructor(
      private $modalInstance:uib.IModalInstanceService,
      private surveyItemsApi:SurveyItemsApiService,
      surveyItemChoice,
      public languages:string[],
      public language:string
   ) {
      this.surveyItemChoice = ng.copy(surveyItemChoice);
      this.mode = surveyItemChoice.id ? 'edit' : 'add';
   }

   onLabelChange(newValue) {
      if (this.mode === 'add' && ng.isDefined(newValue)) {
         let choice = this.surveyItemChoice;
         choice.key = this.surveyItemsApi.keyFromLabel(choice.label[this.language]);
      }
   }

   isEditing() {
      return this.mode === 'add' || this.mode === 'edit';
   }

   cancel() {
      this.$modalInstance.dismiss('cancel');
   }

   save() {
      if (this.mode === 'add') {
         this.surveyItemsApi.addChoice(this.surveyItemChoice)
            .then(() => this.$modalInstance.close());
      } else {
         this.surveyItemsApi.updateChoice(this.surveyItemChoice)
            .then(() => this.$modalInstance.close());
      }
   }
}

ng.module('e360')
   .controller('EditSurveyItemChoiceController', EditSurveyItemChoiceController);
